import { LISTAR_AUDIOS, GET_AUDIO_USE } from './mutation-types'

export default {
  [LISTAR_AUDIOS]: (state, audios) => {
    state.audios = audios
  },
  [GET_AUDIO_USE]: (state, audioUse) => {
    state.audioUse = audioUse
  },
}
